import {Fragment, useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faUser, faKey, faEye, faEyeSlash, faFacebook } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import '../auth.css'
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthApi from "~/api/authApi";
const apiUrl = process.env.REACT_APP_API_URL;
function SignIn(){
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [disableBtn, setDisableBtn] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const loginWindowRef = useRef(null);
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const redirect = searchParams.get("redirect") || "/ai-chatbot";

    useEffect(() => {
        AuthApi.verifyAuthUser()
            .then((res) => {
                navigate("/auth/accounts", {
                    replace: true
                });
            })
            .catch((err) => {
            })
    }, [])

    useEffect(() => {
        const savedRemember = localStorage.getItem("rememberMe") === "true";
        const savedEmail = localStorage.getItem("rememberedEmail");
        const savedPassword = localStorage.getItem("rememberedPassword");

        setRememberMe(savedRemember);
        reset({
            UserNameOrEmail: savedEmail ?? "",
            Password: savedPassword ?? ""
        })
    }, []);

    const onSubmit = (data) => {
        setErrorMessage("");
        setDisableBtn(true);
        axios.post(`${apiUrl}/api/auth/signin`, data, {
            withCredentials: true
        })
            .then((res) => {
                if (res.data?.Succeeded ) {
                    navigate(redirect, { replace: true });
                    localStorage.setItem("rememberMe", rememberMe);
                    if (rememberMe) {
                        localStorage.setItem("rememberedEmail", data.UserNameOrEmail);
                        localStorage.setItem("rememberedPassword", data.Password);
                    } else {
                        localStorage.removeItem("rememberedEmail");
                        localStorage.removeItem("rememberedPassword");
                    }
                }
                else
                {
                    if(res.data?.Requires2FA) {
                        navigate(`/auth/account/2fa-authen/${res.data?.UserId}?redirect=${encodeURIComponent(redirect)}`, { replace: true });
                    }
                    else if (res.data?.Locked){
                        navigate("/auth/lock-account", {
                            replace: true
                        });
                    }
                    else
                    {
                        setErrorMessage(res.data?.Message);
                    }
                }
            })
            .catch((err) => {
                
            })
            .finally(() => {
                setDisableBtn(false)
            })
    };

    const handleExternalLogin = (provider) => {
        if (loginWindowRef.current && !loginWindowRef.current.closed) {
            loginWindowRef.current.close();
        }
        const width = 400;
        const height = 700;
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
        const newWindow = window.open(
            `${apiUrl}/api/auth/external-login?provider=${provider}`,
            '_blank',
            `width=${width},height=${height},top=${top},left=${left},resizable=no`
        );
        loginWindowRef.current = newWindow;
        if (newWindow) newWindow.focus();
    }

    useEffect(() => {
        const handleMessage = (event) => {
            if(event.data?.success){
                if (loginWindowRef.current && !loginWindowRef.current.closed) {
                    loginWindowRef.current.close();
                }
                navigate(redirect, { replace: true });
            }
            else if (event.data?.message === "2FA_REQUIRED") {
                // handle 2FA
                if (loginWindowRef.current && !loginWindowRef.current.closed) {
                    loginWindowRef.current.close();
                }
            }
            else if (event.data?.message) {
                setErrorMessage(event.data?.message);
                if (loginWindowRef.current && !loginWindowRef.current.closed) {
                    loginWindowRef.current.close();
                }
            }
        };

        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, []);


    return (
        <Fragment>
            <div className="text-center mb-7">
                <h3 className="text-body-highlight">Sign In</h3>
                <p className="text-body-tertiary fs-8-1">Sign in to access your account</p>
            </div>
            <button className="btn btn-bt-secondary w-100 mb-3"
                    onClick={() => handleExternalLogin("Google")}
            >
                <svg className="svg-inline--fa fa-google fs-9 me-2 text-danger" aria-hidden="true" focusable="false"
                     data-prefix="fab" data-icon="google" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 488 512" data-fa-i2svg="">
                    <path fill="currentColor"
                          d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"></path>
                </svg>
                Sign in with google
            </button>
            <button className="btn btn-bt-secondary w-100"
                    onClick={() => handleExternalLogin("Facebook")}
            >
                <svg className="svg-inline--fa fa-facebook fs-9 me-2 text-primary" aria-hidden="true" focusable="false"
                     data-prefix="fab" data-icon="facebook" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 512 512" data-fa-i2svg="">
                    <path fill="currentColor"
                          d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"></path>
                </svg>
                Sign in with facebook
            </button>
            <div className="position-relative">
                <hr className="bg-body-secondary mt-5 mb-4"/>
                <div className="divider-content-center">or use email</div>
            </div>
            {
                errorMessage &&
                (
                    <div className="text-center rounded py-1" style={{ backgroundColor: "#f3dfc3" }}>
                        <span className="text-danger fw-bold fs-9">{errorMessage}</span>
                    </div>
                )
            }
            <form onSubmit={handleSubmit(onSubmit)} id="formSignIn">
                <input type="text" style={{ display: "none" }} autoComplete="username" />
                <input type="password" style={{ display: "none" }} autoComplete="current-password" />
                <div className="mb-3 text-start">
                    <label className="form-label" htmlFor="email">Email or username</label>
                    <div className="form-icon-container">
                        <input className="form-control form-icon-input" id="email" type="text" placeholder="name@example.com"
                               {...register("UserNameOrEmail", { required: "Email or username is required" })}/>
                        <FontAwesomeIcon icon={faUser} className="form-icon fs-9 text-body"/>
                    </div>
                    {errors.UserNameOrEmail && (
                        <p className="fs-9 fw-bold text-danger mt-1">{errors.UserNameOrEmail.message}</p>
                    )}
                </div>
                <div className="mb-3 text-start"><label className="form-label" htmlFor="password">Password</label>
                    <div className="form-icon-container" data-password="data-password">
                        <input className="form-control form-icon-input pe-6" id="password" type={!showPassword ? "password" : "text"} placeholder="Password"
                               data-password-input="data-password-input"
                               {...register("Password", { required: "Password is required" })}
                        />
                        <FontAwesomeIcon icon={faKey} className="form-icon fs-9 text-body"/>
                        <button type="button" className="btn px-3 py-0 h-100 position-absolute top-0 end-0 fs-7 text-body-tertiary"
                                data-password-toggle="data-password-toggle">
                            <FontAwesomeIcon onClick={() => setShowPassword(prev => !prev)} icon={!showPassword ? faEye : faEyeSlash} className="fs-9"/>
                            <span className="uil uil-eye-slash hide"></span>
                        </button>
                    </div>
                    {errors.Password && (
                        <p className="fs-9 fw-bold text-danger mt-1">{errors.Password.message}</p>
                    )}
                </div>
            </form>
            <div className="row flex-between-center mb-7">
                <div className="col-auto">
                    <div className="form-check mb-0">
                        <input className="form-check-input" id="basic-checkbox" type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />
                        <label className="form-check-label mb-0" htmlFor="basic-checkbox">Remember me</label>
                    </div>
                </div>
                <div className="col-auto">
                    <Link className="fs-9 fw-semibold" to="/auth/forgot-password">Forgot Password?</Link>
                </div>
            </div>
            <button type="submit" form="formSignIn" disabled={disableBtn} className="btn btn-primary w-100 mb-3">
                {
                    disableBtn && (
                        <span role="status" aria-hidden="true" className="spinner-border spinner-border-sm me-3"></span>
                    )
                }
                Sign In
            </button>
            <div className="text-center">
                <Link className="fs-9 fw-bold" to="/auth/signup">Create an account</Link>
            </div>
        </Fragment>
    )
}

export default SignIn;